function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);

    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
}

function splider() {

    initSplide('.testimonial-col-inner', {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: 24,
        pagination: false,
        arrows: false,
        autoplay: true,
        breakpoints: {
        1024: {
            autoplay: true,
            perPage: 2,
            perMove: 1,
            rewind: true,
            autoplay: true,
            gap: 20,
          },
        767: {
            autoplay: true,
            perPage: 1,
            perMove: 1,
            rewind: true,
            focus  : 'center',
            autoplay: true,
            gap: 20,
          arrows: true,
          },
        }
    });


}

document.addEventListener('DOMContentLoaded', splider);